<template>
  <div>
    <div class="body__container">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <span class="text__visitor mb-0">Visitors</span>
          <b-dropdown
            v-if="isEditRequest && (hasUpdatePermission || !isInternalAccess)"
            no-caret
            dropright
            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
            text="Dark"
            variant="flat-dark"
            size="sm"
            class="btn__visitor-options"
          >
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon"></feather-icon>
            </template>
            <b-dropdown-item @click="onClickCopyVisitorListCreateNewSiteAccess"
              ><feather-icon icon="CopyIcon" class="mr-1"></feather-icon>
              <span>Create new request<br />using visitors information</span>
            </b-dropdown-item>
            <b-dropdown-divider v-if="isCanSelectDropdownMultiVisitor" />
            <b-dropdown-item
              v-if="isCanSelectDropdownMultiVisitor"
              :disabled="isShowAccessForm"
              @click="onClickAddMultiVisitor"
              ><feather-icon icon="CreditCardIcon" class="mr-1"></feather-icon>
              <span>Add multi-visitor card</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="isCanSelectDropdownMultiVisitor"
              :disabled="isShowAccessForm"
              @click="onClickMultiVisitorCheckInOut"
              ><feather-icon icon="ClockIcon" class="mr-1"></feather-icon>
              <span>Check in/out multi-visitor</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>

        <atom-button
          v-if="isShowAddVisitor && (hasUpdatePermission || !isInternalAccess)"
          buttonId="btn-add-visitor"
          buttonStyle="border"
          @click="onClickAddVisitor"
          >Add Visitor</atom-button
        >
      </div>

      <div class="mt-1">
        <b-alert :show="true" variant="secondary" class="w-100">
          <div class="alert-body">
            <strong>Privacy Notice:</strong> The Site Access system records your
            facial image and personal data to verify your identity and keep
            records for future review.
          </div>
        </b-alert>
      </div>

      <label v-if="validateVisitorError" class="text__error"
        >Please add at least 1 visitor</label
      >
      <div
        v-for="(visitor, index) in visitorList"
        :ref="'scrollToVisitor_' + index"
        :key="index"
      >
        <molecule-visitor-card
          :visitor="visitor"
          :status="requestStatus"
          :id-type-options="idTypeOptions"
          :is-card-active="scrollToVisitorId === visitor.id"
          :is-deletable="visitorList.length > 1"
          :hasUpdatePermission="hasUpdatePermission"
          @onResendEmail="onResendEmail"
          @onClickEditVisitorInfo="onClickEditVisitorInfo"
          @onClickDeleteVisitorInfo="onClickDeleteVisitorInfo"
          @updateAccessBuilding="updateAccessBuilding"
          @isShowAccessForm="(isShow) => (isShowAccessForm = isShow)"
        />
      </div>
    </div>

    <div>
      <!-- Modal Add/Edit Visitor Start -->
      <molecule-modal-dialog
        modalId="modal-add-or-edit-visitor-info"
        :isSlotBody="true"
        :buttonTextLeft="`${isEditVisitor ? 'Save Changes' : 'Add'}`"
        buttonTextRight="Cancel"
        :isDisableButtonLeft="isVisitorInfoError"
        :isCloseOnBackDrop="false"
        :isButtonAlignRight="true"
        @clickButtonLeft="onClickConfirmSaveVisitorInfo"
        @clickButtonRight="closeModal"
        @clickIconClose="closeModal"
      >
        <template #body>
          <div class="d-flex flex-column align-items-start w-100">
            <label class="text__modal-title">Visitor Information</label>
            <div class="visitor-info__container w-100">
              <atom-select
                v-model="visitorInfo.visitorType"
                title="Visitor Type"
                placeholder="Select Visitor Type"
                :isClearable="false"
                :isAppendToBody="false"
                :isEnableProper="false"
                :option="visitorTypeOptions"
                :isAsterisk="true"
                @change="onChangeVisitorType"
                class="col-12 col-lg-6 mt-2 px-0"
              />
              <hr class="my-2" />

              <div class="d-lg-flex mt-2">
                <atom-input
                  v-model="visitorInfo.firstname"
                  :title="visitorInfoFirstNameInputTitle"
                  :placeholder="visitorInfoFirstNameInputPlaceholder"
                  :isAsterisk="true"
                  :isError="validateVisitorInfoError.firstnameEmpty"
                  errorMessage="Please enter firstname"
                  class="col-12 col-lg-6 px-0 pr-lg-1"
                />
                <atom-input
                  v-model="visitorInfo.lastname"
                  :title="visitorInfoLastNameInputTitle"
                  :placeholder="visitorInfoLastNameInputPlaceholder"
                  :isAsterisk="true"
                  :isError="validateVisitorInfoError.lastnameEmpty"
                  errorMessage="Please enter lastname"
                  class="col-12 col-lg-6 mt-1 mt-lg-0 px-0 pl-lg-1"
                />
              </div>
              <div class="d-lg-flex mt-1">
                <atom-select
                  v-model="visitorInfo.idType"
                  title="ID Type"
                  placeholder="Select ID Type"
                  label="name"
                  :isClearable="false"
                  :isAppendToBody="false"
                  :isEnableProper="false"
                  :option="idTypeOptions"
                  :isAsterisk="true"
                  :isDisable="true"
                  class="col-12 col-lg-6 px-0 pr-lg-1"
                />
                <atom-input
                  v-model="visitorInfo.idNumber"
                  :title="visitorInfoIdNumberInputTitle"
                  :placeholder="visitorInfoIdNumberInputPlaceholder"
                  :isAsterisk="true"
                  :isError="validateVisitorInfoError.idNumberInvalid"
                  :formatter="
                    isVisitorInfoThai ? onlyNumberFormatter : undefined
                  "
                  errorMessage="Please enter valid ID/Passport Number"
                  class="col-12 col-lg-6 mt-1 mt-lg-0 px-0 pl-lg-1"
                />
              </div>
              <div class="d-lg-flex my-1">
                <atom-input
                  v-model="visitorInfo.email"
                  :title="visitorInfoEmailInputTitle"
                  :placeholder="visitorInfoEmailInputPlaceholder"
                  :isAsterisk="true"
                  :isError="
                    validateVisitorInfoError.emailEmpty ||
                    validateVisitorInfoError.emailInvalid
                  "
                  :errorMessage="
                    validateVisitorInfoError.emailEmpty
                      ? 'Please enter email'
                      : 'Please enter valid email'
                  "
                  class="col-12 col-lg-6 px-0 pr-lg-1"
                />
                <atom-input
                  v-model="visitorInfo.phone"
                  title="Phone"
                  placeholder="Phone"
                  :isAsterisk="true"
                  :isError="validateVisitorInfoError.phoneEmpty"
                  :errorMessage="
                    validateVisitorInfoError.phoneEmpty
                      ? 'Please enter phone'
                      : 'Please enter valid phone'
                  "
                  class="col-12 col-lg-6 mt-1 mt-lg-0 px-0 pl-lg-1"
                />
              </div>
            </div>
          </div>
        </template>
      </molecule-modal-dialog>
      <!-- Modal Add/Edit Visitor End -->

      <!-- Modal Add Multi Visitor Start -->
      <div>
        <molecule-modal-dialog
          modalId="modal-add-multi-visitor-options"
          :isSlotBody="true"
          textTitle="Add Multi-visitor Card"
          buttonTextLeft="Next"
          :isDisableButtonLeft="
            !selectVisitors.some((visitor) => visitor.isChecked)
          "
          :isCloseOnBackDrop="false"
          :isButtonRight="false"
          @clickButtonLeft="onClickSelectAddMultiVisitor"
          @clickIconClose="closeModal"
        >
          <template #body>
            <div class="add-multi-visitor-options__container max-h-modal">
              <label class="text__select-visitor">Select visitors</label>
              <div
                v-for="(visitor, index) in selectVisitors"
                :key="index"
                class="d-flex justify-content-start w-100 mt-1"
              >
                <atom-checkbox
                  v-model="visitor.isChecked"
                  :title="visitor.name"
                  :isColorTextOnActive="true"
                ></atom-checkbox>
              </div>
            </div>
          </template>
        </molecule-modal-dialog>

        <molecule-modal-dialog
          modalId="modal-add-multi-visitor-forms"
          :isSlotBody="true"
          textTitle="Add Multi-visitor Building Card"
          buttonTextLeft="Back"
          buttonStyleLeft="border"
          buttonColorLeft="secondary"
          buttonTextRight="Add Card"
          buttonStyleRight="filled"
          buttonColorRight="primary"
          :isDisableButtonLeft="isVisitorInfoError"
          :isDisableButtonRight="isMissingSomeBuildingCardInAddMultiCard"
          :isCloseModal="false"
          :isCloseOnBackDrop="false"
          @clickButtonLeft="onClickAddMultiVisitor"
          @clickButtonRight="onClickAddMultiVisitorCard"
          @clickIconClose="closeModal"
        >
          <template #body>
            <div class="add-multi-visitor-forms__container max-h-modal">
              <div
                v-for="(visitor, index) in multiVisitorCard"
                :key="index"
                class="add-multi-visitor-forms__card"
                :class="{ 'mt-12px': index > 0 }"
              >
                <label class="text__visitor-name-forms mb-1">{{
                  visitor.name
                }}</label>
                <div
                  v-if="multiVisitorCard[index].latestBuildCard"
                  class="mb-1"
                >
                  <div
                    class="d-flex align-items-center"
                    @click="
                      visitor.isShowLatestCheckInCheckOut =
                        !visitor.isShowLatestCheckInCheckOut
                    "
                  >
                    <label class="text-more-or-less pb-0"
                      >First Check In / Last Check Out</label
                    >
                    <feather-icon
                      class="icon-more-or-less"
                      :icon="`${
                        !visitor.isShowLatestCheckInCheckOut
                          ? 'ChevronDownIcon'
                          : 'ChevronUpIcon'
                      }`"
                      size="14"
                    />
                  </div>
                  <div
                    v-if="visitor.isShowLatestCheckInCheckOut"
                    class="d-flex mt-7px"
                  >
                    <div class="w-50 pr-8px">
                      <div class="text__latest-access-building-topic">
                        First Check In Date
                      </div>
                      <div
                        class="text__latest-access-building-body custom-margin-top-3"
                      >
                        {{
                          multiVisitorCard[index].latestBuildCard.checkInDate ||
                          "-"
                        }}
                      </div>
                    </div>
                    <div class="w-50 pl-8px">
                      <div class="text__latest-access-building-topic">
                        Last Check Out Date
                      </div>
                      <div
                        class="text__latest-access-building-body custom-margin-top-3"
                      >
                        {{
                          multiVisitorCard[index].latestBuildCard
                            .checkOutDate || "-"
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <atom-input
                  v-model="
                    multiVisitorCard[index].accessBuilding[0].buildingCard
                  "
                  title="Building Card No"
                  placeholder="Building Card No"
                  :isAsterisk="true"
                  :isError="
                    isApplyErrorMultiVisitorCard &&
                    !multiVisitorCard[index].accessBuilding[0].buildingCard
                  "
                  errorMessage="Please enter building card no"
                  class="col-12 col-lg-6 px-0"
                />

                <label class="text-access-topic">NTDC Card</label>
                <div class="custom-margin-top-6 col-12 col-lg-9 px-0 d-lg-flex">
                  <div class="col-12 col-lg-6 p-0 pr-lg-4px">
                    <atom-datepicker
                      datepickerId="check-in-date"
                      title="Check In Date"
                      v-model="
                        multiVisitorCard[index].accessBuilding[0].accessCard[0]
                          .checkInDate
                      "
                      placeholder="Check In Date"
                      :maxDate="
                        multiVisitorCard[index].accessBuilding[0].accessCard[0]
                          .checkOutDate
                      "
                      type="dateNtime"
                      :showSetTimeNowButton="true"
                    ></atom-datepicker>
                  </div>
                  <div class="col-12 col-lg-6 p-0 mt-1 mt-lg-0 pl-lg-4px">
                    <atom-datepicker
                      datepickerId="check-out-date"
                      title="Check Out Date"
                      v-model="
                        multiVisitorCard[index].accessBuilding[0].accessCard[0]
                          .checkOutDate
                      "
                      placeholder="Check Out Date"
                      :minDate="
                        multiVisitorCard[index].accessBuilding[0].accessCard[0]
                          .checkInDate
                      "
                      type="dateNtime"
                      :showSetTimeNowButton="true"
                    ></atom-datepicker>
                  </div>
                </div>
                <div class="mt-1 col-12 col-lg-9 px-0 d-lg-flex">
                  <div class="col-12 col-lg-6 p-0 pr-lg-4px d-lg-flex">
                    <atom-input
                      v-model="
                        multiVisitorCard[index].accessBuilding[0].accessCard[0]
                          .location
                      "
                      title="Location"
                      placeholder="Location"
                      class="col-12 p-0"
                    />
                  </div>
                  <div class="col-12 col-lg-6 p-0 pl-lg-4px d-lg-flex">
                    <atom-input
                      v-model="
                        multiVisitorCard[index].accessBuilding[0].accessCard[0]
                          .cardType
                      "
                      title="Card Type"
                      placeholder="Card Type"
                      class="col-12 col-lg-6 p-0 mt-1 mt-lg-0 pr-lg-4px"
                    />
                    <atom-input
                      v-model="
                        multiVisitorCard[index].accessBuilding[0].accessCard[0]
                          .cardNumber
                      "
                      title="Card No"
                      placeholder="Card No"
                      class="col-12 col-lg-6 p-0 mt-1 mt-lg-0 pl-lg-4px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </molecule-modal-dialog>

        <molecule-modal-dialog
          modalId="modal-multi-check-in-out-options"
          :isSlotBody="true"
          textTitle="Check In/Out Multi-visitor"
          buttonTextLeft="Next"
          :isDisableButtonLeft="!isSelectCheckInOut || !multiCheckInOutDate"
          :isCloseOnBackDrop="false"
          :isButtonRight="false"
          @clickButtonLeft="onClickViewMultiCheckInOut"
          @clickIconClose="closeModal"
        >
          <template #body>
            <div class="add-multi-check-in-out-options__container max-h-modal">
              <label class="text__select-check-type"
                >Select Check Type<span class="text__asterisk">*</span></label
              >
              <div class="d-lg-flex mt-1 w-100">
                <div
                  v-for="(option, index) in checkTypeList"
                  :key="index"
                  @click="onSelectType(index)"
                  class="w-lg-50"
                  :class="[
                    index === 0 ? 'pr-lg-8px' : 'pl-lg-8px mt-1 mt-lg-0',
                  ]"
                >
                  <div
                    class="text-center check-type__box"
                    :class="{
                      'check-type__box-active':
                        selectMultiVisitorCheckType.id === option.id,
                    }"
                  >
                    {{ option.name }}
                  </div>
                </div>
              </div>

              <label class="text__select-visitor mt-32px"
                >Select visitors</label
              >
              <div
                v-for="(visitor, index) in multiVisitorCheckInOut"
                :key="index"
              >
                <div class="d-flex justify-content-start w-100 mt-1 mb-2">
                  <atom-checkbox
                    v-model="visitor.isChecked"
                    :title="
                      visitor.accessBuilding.length
                        ? `${visitor.firstname} ${visitor.lastname}`
                        : `${visitor.firstname} ${visitor.lastname} (No Building Card)`
                    "
                    :isColorTextOnActive="true"
                    :isDisable="!visitor.accessBuilding.length"
                  ></atom-checkbox>
                </div>

                <div v-if="visitor.isChecked" class="select-visitor__container">
                  <div
                    v-for="(building, buildingIndex) in visitor.accessBuilding"
                    :key="buildingIndex"
                    :class="{ 'mt-10px': buildingIndex > 0 }"
                  >
                    <label class="text__building-card-no"
                      >Building Card No:
                      <span class="font-weight-bold pl-8px">{{
                        building.buildingCard
                      }}</span></label
                    >
                    <div class="pl-8px">
                      <div
                        v-for="(access, accessIndex) in building.accessCard"
                        :key="accessIndex"
                      >
                        <div class="d-lg-flex w-100 mt-10px">
                          <div class="d-flex w-lg-50 pr-lg-8px">
                            <atom-checkbox
                              v-model="access.isCheckIn"
                              :isColorTextOnActive="true"
                              :isDisable="!isSelectCheckIn"
                            ></atom-checkbox>
                            <span
                              class="text__access"
                              :class="{
                                'text__access-active':
                                  access.isCheckIn && isSelectCheckIn,
                              }"
                              >Check In:<span class="font-weight-bold pl-8px">{{
                                access.checkInDate
                                  ? formatDateTime(access.checkInDate)
                                  : "-"
                              }}</span></span
                            >
                          </div>
                          <div class="d-flex w-lg-50 pl-lg-8px mt-1 mt-lg-0">
                            <atom-checkbox
                              v-model="access.isCheckOut"
                              :isColorTextOnActive="true"
                              :isDisable="isSelectCheckIn"
                            ></atom-checkbox>
                            <span
                              class="text__access"
                              :class="{
                                'text__access-active':
                                  access.isCheckOut && !isSelectCheckIn,
                              }"
                              >Check Out:<span
                                class="font-weight-bold pl-8px"
                                >{{
                                  access.checkOutDate
                                    ? formatDateTime(access.checkOutDate)
                                    : "-"
                                }}</span
                              ></span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <atom-datepicker
                v-if="isSelectCheckInOut"
                datepickerId="multi-check-date"
                :title="selectMultiVisitorCheckType.name"
                :isAsterisk="true"
                v-model="multiCheckInOutDate"
                :placeholder="selectMultiVisitorCheckType.name"
                type="dateNtime"
                class="mt-32px"
                :showSetTimeNowButton="true"
              ></atom-datepicker>
            </div>
          </template>
        </molecule-modal-dialog>

        <molecule-modal-dialog
          modalId="modal-multi-check-in-out-view-confirm"
          :isSlotBody="true"
          :textTitle="`${selectMultiVisitorCheckType.name} Multi-visitor`"
          buttonTextLeft="Back"
          buttonStyleLeft="border"
          buttonColorLeft="secondary"
          :buttonTextRight="`${selectMultiVisitorCheckType.name}`"
          buttonStyleRight="filled"
          buttonColorRight="primary"
          :isCloseOnBackDrop="false"
          @clickButtonLeft="openModal('modal-multi-check-in-out-options')"
          @clickButtonRight="onClickConfirmCheckInOut"
          @clickIconClose="closeModal"
        >
          <template #body>
            <div class="add-multi-visitor-forms__container max-h-modal">
              <div
                v-for="(visitor, index) in multiVisitorCheckInOutForView"
                :key="index"
                class="add-multi-visitor-forms__card"
                :class="{ 'mt-12px': index > 0 }"
              >
                <label class="text__visitor-name-forms">{{
                  `${visitor.firstname} ${visitor.lastname}`
                }}</label>

                <div
                  v-for="(
                    accessBuilding, buildingIndex
                  ) in visitor.accessBuilding"
                  :key="buildingIndex"
                >
                  <hr v-if="buildingIndex > 0" />

                  <div class="col-12 col-lg-6 px-0">
                    <label
                      >Building Card No
                      <span class="font-weight-bold pl-8px">{{
                        accessBuilding.buildingCard
                      }}</span></label
                    >
                  </div>

                  <label class="text-access-topic">NTDC Card</label>
                  <div
                    v-for="(
                      accessCard, accessIndex
                    ) in accessBuilding.accessCard"
                    :key="accessIndex"
                    class="text__access-body"
                  >
                    <hr v-if="accessIndex > 0" />
                    <div
                      class="custom-margin-top-6 col-12 col-lg-10 px-0 d-lg-flex"
                    >
                      <div
                        class="col-12 col-lg-6 p-0 pr-lg-4px"
                        :class="{
                          'text__access-body-active': isSelectCheckIn,
                        }"
                      >
                        <div
                          class="text__access-topic"
                          :class="{
                            'text__access-topic-active': isSelectCheckIn,
                          }"
                        >
                          Check In Date
                        </div>
                        <div
                          class="custom-margin-top-4"
                          :class="{ 'font-weight-bold': isSelectCheckIn }"
                        >
                          {{
                            accessCard.checkInDate
                              ? formatDateTimeWithDay(accessCard.checkInDate)
                              : "-"
                          }}
                        </div>
                      </div>
                      <div
                        class="col-12 col-lg-6 p-0 mt-1 mt-lg-0 pl-lg-4px"
                        :class="{
                          'text__access-body-active': !isSelectCheckIn,
                        }"
                      >
                        <div
                          class="text__access-topic"
                          :class="{
                            'text__access-topic-active': !isSelectCheckIn,
                          }"
                        >
                          Check Out Date
                        </div>
                        <div
                          class="custom-margin-top-4"
                          :class="{ 'font-weight-bold': !isSelectCheckIn }"
                        >
                          {{
                            accessCard.checkOutDate
                              ? formatDateTimeWithDay(accessCard.checkOutDate)
                              : "-"
                          }}
                        </div>
                      </div>
                    </div>

                    <div class="mt-1 col-12 col-lg-10 px-0 d-lg-flex">
                      <div class="col-12 col-lg-6 p-0 pr-lg-4px">
                        <div class="text__access-topic">Location</div>
                        <div class="custom-margin-top-4">
                          {{ accessCard.location || "-" }}
                        </div>
                      </div>
                      <div class="col-12 col-lg-6 p-0 pl-lg-4px d-lg-flex">
                        <div class="col-12 col-lg-6 p-0 mt-1 mt-lg-0 pr-lg-4px">
                          <div class="text__access-topic">Card Type</div>
                          <div class="custom-margin-top-4">
                            {{ accessCard.cardType || "-" }}
                          </div>
                        </div>
                        <div class="col-12 col-lg-6 p-0 mt-1 mt-lg-0 pl-lg-4px">
                          <div class="text__access-topic">Card No</div>
                          <div class="custom-margin-top-4">
                            {{ accessCard.cardNumber || "-" }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </molecule-modal-dialog>
      </div>
      <!-- Modal Add Multi Visitor End -->
    </div>
  </div>
</template>

<script>
import mixinsDateTime from "@/mixins/mixinsDatetime"
import mixinsValidator from "@/mixins/mixinsValidator"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"
import mixinsFormatter from "@/mixins/mixinsFormatter"
import {
  BDropdown,
  BDropdownDivider,
  BDropdownItem,
  BAlert,
} from "bootstrap-vue"
import Ripple from "vue-ripple-directive"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomDatepicker from "@/components/atoms/AtomDatepicker.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomCheckbox from "@/components/atoms/AtomCheckbox.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import MoleculeVisitorCard from "@/components/molecules/portal/qrAccess/MoleculeVisitorCard.vue"
import { IdTypeOption, VisitorTypeOptions } from "@/constants"

export default {
  name: "MoleculeVisitorCardGroup",
  components: {
    AtomInput,
    AtomButton,
    AtomDatepicker,
    AtomSelect,
    AtomCheckbox,
    MoleculeModalDialog,
    MoleculeVisitorCard,
    BDropdown,
    BDropdownDivider,
    BDropdownItem,
    BAlert,
  },
  directives: {
    Ripple,
  },
  mixins: [
    mixinsDateTime,
    mixinsValidator,
    mixinsObjectHelper,
    mixinsFormatter,
  ],
  props: {
    idTypeOptions: {
      type: Array,
      required: false,
      default: () => [
        {
          id: IdTypeOption.ID_CARD,
          name: "บัตรประจำตัวประชาชน",
        },
        {
          id: IdTypeOption.PASSPORT,
          name: "Passport",
        },
      ],
    },
    requestStatus: {
      type: String,
      required: false,
      default: "NEW",
    },
    visitorListProp: {
      type: Array,
      required: false,
      default: () => [],
    },
    validateVisitorError: {
      type: Boolean,
      required: false,
      default: false,
    },
    visitorOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    scrollToVisitorId: {
      type: String,
      required: false,
      default: "",
    },
    hasUpdatePermission: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: [
    "updateVisitorList",
    "clickCopyVisitorListCreateNewSiteAccess",
    "onResendEmail",
  ],
  data() {
    return {
      visitorTypeOptions: VisitorTypeOptions,

      isEditVisitor: false,

      visitorList: [],

      visitorInfo: {},

      isApplyValidateVisitorInfo: false,
      validateVisitorInfoError: {
        firstnameEmpty: false,
        lastnameEmpty: false,
        idNumberInvalid: false,
        emailEmpty: false,
        emailInvalid: false,
        phoneEmpty: false,
      },

      // Add multi visitor
      selectVisitors: [],
      multiVisitorCard: [
        {
          id: null,
          firstname: null,
          lastname: null,
          idType: null,
          idNumber: null,
          email: null,
          phone: null,
          selfCheckIn: {
            dateFirstCheckIn: null,
            dateLastCheckIn: null,
            selfCheckInAt: null,
            name: null,
            idNumber: null,
            idExpiredDate: null,
            nationality: null,
            address: null,
            image: null,
          },
          accessBuilding: [
            {
              buildingCard: "",
              accessCard: [
                {
                  location: "",
                  cardType: "",
                  cardNumber: "",
                  checkInDate: null,
                  checkOutDate: null,
                },
              ],
            },
          ],
        },
      ],
      isShowLatestBuildingCard: false,
      isApplyErrorMultiVisitorCard: false,

      selectMultiVisitorCheckType: {
        id: null,
        name: null,
      },
      checkTypeList: [
        {
          id: "check-in",
          name: "Check In",
        },
        {
          id: "check-out",
          name: "Check Out",
        },
      ],
      multiVisitorCheckInOut: [
        {
          id: null,
          firstname: null,
          lastname: null,
          isChecked: false,
          accessBuilding: [
            {
              buildingCard: "",
              accessCard: [
                {
                  cardNumber: "",
                  checkInDate: null,
                  checkOutDate: null,
                  isCheckIn: false,
                  isCheckOut: false,
                },
              ],
            },
          ],
        },
      ],
      multiVisitorCheckInOutForView: [
        {
          id: null,
          firstname: null,
          lastname: null,
          isChecked: false,
          accessBuilding: [
            {
              buildingCard: "",
              accessCard: [
                {
                  location: "",
                  cardType: "",
                  cardNumber: "",
                  checkInDate: null,
                  checkOutDate: null,
                  isCheckIn: false,
                  isCheckOut: false,
                },
              ],
            },
          ],
        },
      ],
      multiCheckInOutDate: null,
      isShowAccessForm: false,
    }
  },
  computed: {
    isEditRequest() {
      return !!this.$route.params.id
    },
    isInternalAccess() {
      return this.$route.meta.type === "internal"
    },
    isVisitorInfoError() {
      return Object.values(this.validateVisitorInfoError).some(
        (error) => error === true
      )
    },
    isWaiting() {
      return this.requestStatus === "WAITING"
    },
    isApproved() {
      return this.requestStatus === "APPROVED"
    },
    isAccess() {
      return this.requestStatus === "ACCESS"
    },
    isRejected() {
      return this.requestStatus === "REJECTED"
    },
    isClosed() {
      return this.requestStatus === "CLOSED"
    },
    isShowAddVisitor() {
      if (!this.isEditRequest || this.isWaiting) return true

      if (this.isApproved || this.isAccess) return this.isInternalAccess

      return false
    },
    isSelectCheckIn() {
      return this.selectMultiVisitorCheckType.id === this.checkTypeList[0].id
    },
    isSelectCheckInOut() {
      const selectVisitors = this.multiVisitorCheckInOut.filter(
        (visitor) => visitor.isChecked
      )

      if (!selectVisitors.length) return false

      if (this.isSelectCheckIn) {
        return selectVisitors.some((visitor) => {
          return visitor.accessBuilding.some((b) =>
            b.accessCard.some((a) => a.isCheckIn)
          )
        })
      }

      return selectVisitors.some((visitor) => {
        return visitor.accessBuilding.some((b) =>
          b.accessCard.some((a) => a.isCheckOut)
        )
      })
    },
    isCanSelectDropdownMultiVisitor() {
      return this.isInternalAccess && (this.isAccess || this.isApproved)
    },
    isMissingSomeBuildingCardInAddMultiCard() {
      return this.isApplyErrorMultiVisitorCard
        ? this.multiVisitorCard.some((accessInfo) =>
            accessInfo.accessBuilding.some(
              (accessBuilding) => !accessBuilding.buildingCard
            )
          )
        : false
    },
    isVisitorInfoThai() {
      return this.visitorInfo.visitorType === "Thai"
    },
    visitorInfoFirstNameInputTitle() {
      return this.isVisitorInfoThai ? "ชื่อ (ภาษาไทย)" : "First Name"
    },
    visitorInfoFirstNameInputPlaceholder() {
      return this.isVisitorInfoThai ? "ชื่อ" : "First Name"
    },
    visitorInfoLastNameInputTitle() {
      return this.isVisitorInfoThai ? "นามสกุล (ภาษาไทย)" : "Last Name"
    },
    visitorInfoLastNameInputPlaceholder() {
      return this.isVisitorInfoThai ? "นามสกุล" : "Last Name"
    },
    visitorInfoIdNumberInputTitle() {
      return this.isVisitorInfoThai
        ? "เลขบัตรประจำตัวประชาชน (กรอกตัวเลขเท่านั้น)"
        : "Passport Number"
    },
    visitorInfoIdNumberInputPlaceholder() {
      return this.isVisitorInfoThai
        ? "เลขบัตรประจำตัวประชาชน"
        : "Passport Number"
    },
    visitorInfoEmailInputTitle() {
      return this.isVisitorInfoThai
        ? "อีเมล (สำหรับรับ QR Code รายบุคคล)"
        : "Email (for Receive QR Code)"
    },
    visitorInfoEmailInputPlaceholder() {
      return this.isVisitorInfoThai ? "อีเมล" : "Email"
    },
  },
  watch: {
    visitorListProp: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.fetchVisitorData()
        }
      },
    },
    "visitorInfo.visitorType": {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === this.visitorTypeOptions[0]) {
            this.visitorInfo.idType = this.deepCopyObject(this.idTypeOptions[0])
          } else {
            this.visitorInfo.idType = this.deepCopyObject(this.idTypeOptions[1])
          }
        }
      },
    },
    visitorInfo: {
      deep: true,
      handler() {
        this.validateVisitorInfo()
      },
    },
    scrollToVisitorId: {
      deep: true,
      handler() {
        this.scrollToVisitor(this.scrollToVisitorId)
      },
    },
  },
  mounted() {
    this.fetchVisitorData()
    this.setVisitorInfoToDefault()
  },
  methods: {
    fetchVisitorData() {
      this.visitorList = this.deepCopyArray(this.visitorListProp)
    },
    scrollToVisitor(visitorId) {
      this.$nextTick(() => {
        const targetIndex = this.visitorList.findIndex(
          (item) => item.id === visitorId
        )
        const visitorTarget = `scrollToVisitor_${targetIndex}`
        const visitorCardRef = this.$refs[visitorTarget]
        if (visitorCardRef && visitorCardRef.length > 0) {
          const element = visitorCardRef[0]
          const targetOffset = element.offsetTop
          window.scrollTo({
            top: targetOffset,
            behavior: "smooth",
          })
        }
      })
    },

    // Visitor Info Start
    onClickAddVisitor() {
      this.isEditVisitor = false

      this.setVisitorInfoToDefault()

      this.openModal("modal-add-or-edit-visitor-info")
    },

    onClickEditVisitorInfo(id) {
      this.isEditVisitor = true

      this.setVisitorInfoToDefault(id)

      this.openModal("modal-add-or-edit-visitor-info")
    },

    onClickConfirmSaveVisitorInfo() {
      this.isApplyValidateVisitorInfo = true

      this.validateVisitorInfo()

      if (!this.isVisitorInfoError) {
        if (this.isEditVisitor) {
          this.visitorList = this.deepCopyArray(
            this.visitorList.map((item) => {
              if (item.id === this.visitorInfo.id) {
                return this.visitorInfo
              }

              return item
            })
          )
        } else {
          this.visitorList = this.deepCopyArray([
            ...this.visitorList,
            this.visitorInfo,
          ])
        }

        this.$emit("updateVisitorList", this.visitorList)

        this.closeModal()
      }
    },

    onClickDeleteVisitorInfo(id) {
      this.visitorList = this.deepCopyArray(
        this.visitorList.filter((item) => item.id !== id)
      )

      this.$emit("updateVisitorList", this.visitorList)
    },

    updateAccessBuilding(id, accessBuilding) {
      this.visitorList = this.visitorList.map((visitorInfo) => {
        if (visitorInfo.id === id) {
          return {
            ...visitorInfo,
            accessBuilding,
          }
        }

        return visitorInfo
      })

      this.$emit("updateVisitorList", this.visitorList)
    },

    validateVisitorInfo() {
      if (!this.isApplyValidateVisitorInfo) {
        this.validateVisitorInfoError = this.deepCopyObject({
          firstnameEmpty: false,
          lastnameEmpty: false,
          idNumberInvalid: false,
          emailEmpty: false,
          emailInvalid: false,
          phoneEmpty: false,
        })
      } else {
        this.validateVisitorInfoError = this.deepCopyObject({
          firstnameEmpty: this.isEmptyString(this.visitorInfo.firstname),
          lastnameEmpty: this.isEmptyString(this.visitorInfo.lastname),
          idNumberInvalid: this.isVisitorInfoThai
            ? this.isInvalidThaiId(this.visitorInfo.idNumber)
            : this.isEmptyString(this.visitorInfo.idNumber),
          emailEmpty: this.isEmptyString(this.visitorInfo.email),
          emailInvalid: this.isInvalidEmail(this.visitorInfo.email),
          phoneEmpty: this.isEmptyString(this.visitorInfo.phone),
        })
      }
    },

    setVisitorInfoToDefault(visitorId) {
      if (this.isEditVisitor && !!visitorId) {
        const visitorInfo = this.visitorList.find(
          (info) => info.id === visitorId
        )
        this.visitorInfo = this.deepCopyObject({
          id: visitorInfo.id,
          visitorType: this.deepCopyObject(
            visitorInfo.idType.id === this.idTypeOptions[0].id
              ? this.visitorTypeOptions[0]
              : this.visitorTypeOptions[1]
          ),
          firstname: visitorInfo.firstname,
          lastname: visitorInfo.lastname,
          idType: this.deepCopyObject(visitorInfo.idType),
          idNumber: visitorInfo.idNumber,
          email: visitorInfo.email,
          phone: visitorInfo.phone,
        })
      } else {
        this.visitorInfo = this.deepCopyObject({
          id: `NEW_VISITOR_${this.visitorList.length + 1}`,
          visitorType: this.visitorTypeOptions[0],
          firstname: null,
          lastname: null,
          idType: this.idTypeOptions[0],
          idNumber: null,
          email: null,
          phone: null,
        })
      }

      this.isApplyValidateVisitorInfo = false

      this.validateVisitorInfoError = this.deepCopyObject({
        firstnameEmpty: false,
        lastnameEmpty: false,
        idNumberInvalid: false,
        emailEmpty: false,
        emailInvalid: false,
        phoneEmpty: false,
      })
    },

    onChangeVisitorType() {
      this.visitorInfo.idNumber = null
    },
    // Visitor Info End

    // Add Multi Visitor Start
    onClickAddMultiVisitor() {
      if (this.modalId) {
        this.closeModal()
      } else {
        this.selectVisitors = this.visitorOptions.map((visitor) => ({
          ...visitor,
          isChecked: false,
        }))
      }

      this.isApplyErrorMultiVisitorCard = false
      this.openModal("modal-add-multi-visitor-options")
    },

    onClickSelectAddMultiVisitor() {
      const visitors = this.selectVisitors.filter(
        (visitor) => visitor.isChecked
      )

      this.multiVisitorCard = visitors.map((visitor) => ({
        ...visitor,
        isShowLatestCheckInCheckOut: false,
        accessBuilding: [
          {
            buildingCard: "",
            accessCard: [
              {
                location: "",
                cardType: "",
                cardNumber: "",
                checkInDate: null,
                checkOutDate: null,
              },
            ],
          },
        ],
      }))

      this.closeModal()
      this.openModal("modal-add-multi-visitor-forms")
    },

    onClickAddMultiVisitorCard() {
      this.isApplyErrorMultiVisitorCard = true
      if (!this.isMissingSomeBuildingCardInAddMultiCard) {
        const visitors = this.visitorList.map((visitor) => {
          const multiVisitorCard = this.multiVisitorCard.find(
            (item) => item.id === visitor.id
          )
          if (multiVisitorCard) {
            return {
              ...visitor,
              accessBuilding: [
                ...multiVisitorCard.accessBuilding,
                ...visitor.accessBuilding,
              ],
            }
          }
          return visitor
        })
        this.$emit("updateVisitorList", visitors)
        this.closeModal()
        this.isApplyErrorMultiVisitorCard = false
      }
    },

    onClickMultiVisitorCheckInOut() {
      this.onSelectType(0)
      this.multiCheckInOutDate = null

      this.openModal("modal-multi-check-in-out-options")
    },
    onSelectType(index) {
      this.multiCheckDate = new Date()

      this.selectMultiVisitorCheckType = this.deepCopyObject(
        this.checkTypeList[index]
      )

      this.multiVisitorCheckInOut = this.deepCopyArray(
        this.visitorList.map((visitor) => ({
          ...visitor,
          isChecked: false,
          accessBuilding: visitor.accessBuilding.map((building) => ({
            ...building,
            accessCard: building.accessCard.map((access) => ({
              ...access,
              isCheckIn: false,
              isCheckOut: false,
            })),
          })),
        }))
      )
    },

    onClickViewMultiCheckInOut() {
      const selectVisitors = []

      this.multiVisitorCheckInOut
        .filter((visitor) => visitor.isChecked)
        .forEach((visitor) => {
          const accessBuildings = []

          visitor.accessBuilding.forEach((building) => {
            const accessCards = []

            building.accessCard.forEach((access) => {
              if (this.isSelectCheckIn && access.isCheckIn) {
                accessCards.push({
                  ...access,
                  checkInDate: this.multiCheckInOutDate,
                })
              } else if (!this.isSelectCheckIn && access.isCheckOut) {
                accessCards.push({
                  ...access,
                  checkOutDate: this.multiCheckInOutDate,
                })
              }
            })

            if (accessCards.length) {
              accessBuildings.push({
                ...building,
                accessCard: accessCards,
              })
            }
          })

          if (accessBuildings.length) {
            selectVisitors.push({
              ...visitor,
              accessBuilding: accessBuildings,
            })
          }
        })

      this.multiVisitorCheckInOutForView = this.deepCopyArray(selectVisitors)

      this.openModal("modal-multi-check-in-out-view-confirm")
    },
    onClickConfirmCheckInOut() {
      const visitors = this.multiVisitorCheckInOut.map((visitor) => {
        if (visitor.isChecked) {
          return {
            ...visitor,
            isChecked: undefined,
            accessBuilding: visitor.accessBuilding.map((building) => {
              if (this.isSelectCheckIn) {
                return {
                  ...building,
                  accessCard: building.accessCard.map((access) => {
                    if (access.isCheckIn) {
                      return {
                        ...access,
                        isCheckIn: undefined,
                        isCheckOut: undefined,
                        checkInDate: this.multiCheckInOutDate,
                      }
                    }
                    return {
                      ...access,
                      isCheckIn: undefined,
                      isCheckOut: undefined,
                    }
                  }),
                }
              }

              return {
                ...building,
                accessCard: building.accessCard.map((access) => {
                  if (access.isCheckOut) {
                    return {
                      ...access,
                      isCheckIn: undefined,
                      isCheckOut: undefined,
                      checkOutDate: this.multiCheckInOutDate,
                    }
                  }
                  return {
                    ...access,
                    isCheckIn: undefined,
                    isCheckOut: undefined,
                  }
                }),
              }
            }),
          }
        }

        return { ...visitor, isChecked: undefined }
      })

      this.$emit("updateVisitorList", visitors)

      this.closeModal()
    },
    // Add Multi Visitor End

    // Datetime Start
    formatDateTime(datetime) {
      return this.setDateTimeFormat(datetime, "dd/MM/yyyy HH:mm")
    },
    formatDateTimeWithDay(datetime) {
      return this.setDateTimeFormat(datetime, "cccc, d LLLL yyyy HH:mm")
    },
    // Datetime End

    onClickCopyVisitorListCreateNewSiteAccess() {
      this.$emit("clickCopyVisitorListCreateNewSiteAccess")
    },

    onResendEmail(visitorId) {
      this.$emit("onResendEmail", visitorId)
    },

    // Modal Start
    openModal(modalId) {
      this.closeModal()
      this.modalId = modalId
      this.$bvModal.show(this.modalId)
    },

    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
    },
    // Modal End
  },
}
</script>

<style lang="scss" scoped>
hr {
  width: 100%;
  stroke-width: 1px;
  stroke: #e9ecef;
}

.body__container {
  width: 100%;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.06);
  padding: 21px;
}

.text__visitor {
  color: #5e5873;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 35px;
  text-transform: uppercase;
}

.text__error {
  color: #ea5455;
  font-size: 12px;
  margin-top: 4px;
  line-height: 1.5;
}

.text__modal-title {
  color: #5e5873;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
}

.text__select-visitor {
  color: #b9b9c3;
  font-weight: 500;
  font-size: 16;
  text-transform: uppercase;
}

.text__latest-access-building-topic {
  color: #b9b9c3;
  font-weight: 400;
  font-size: 12px;
  text-transform: uppercase;
}

.text__latest-access-building-body {
  color: #5e5873;
  font-weight: 400;
  font-size: 14px;
}

.add-multi-visitor-options__container,
.add-multi-check-in-out-options__container {
  padding: 10px;
  width: 100%;
}

.add-multi-visitor-forms__container {
  padding: 20px;
  width: 100%;
}

.add-multi-visitor-forms__card {
  border: 1px solid #b9b9c3;
  border-radius: 6px;
  padding: 16px;
}

.mt-7px {
  margin-top: 7px;
}

.mt-12px {
  margin-top: 12px;
}

.text__visitor-name-forms {
  color: #5e5873;
  font-weight: 500;
  font-size: 18px;
}

.text-more-or-less {
  color: #b9b9c3;
  font-size: 12px;
  font-weight: 400;
  text-decoration-line: underline;
  cursor: pointer;
  margin-right: 4px;
}

.icon-more-or-less {
  color: #b9b9c3;
  cursor: pointer;
}

.text-access-topic {
  color: #6e6b7b;
  font-size: 14px;
  font-weight: 600;
  text-decoration-line: underline;
  margin-top: 20px;
}

.max-h-modal {
  max-height: calc(100lvh - 3.5rem - 200px);
  overflow-y: auto;
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
  .pl-lg-4px {
    padding-left: 4px !important;
  }

  .pr-lg-4px {
    padding-right: 4px !important;
  }
}

.select-visitor__container {
  border: 1px dashed rgba(115, 103, 240, 0.4);
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 10px;
  padding: 12px;
}

.check-type__box {
  cursor: pointer;
  background: #fbfbfc;
  border: 1px solid #82868b;
  padding: 13px;
  border-radius: 6px;
  color: #82868b;
  font-weight: 500;
  font-size: 14px;
}

.check-type__box-active {
  background: #f7f6fe;
  border: 1px solid #7367f0;
  color: #7367f0;
}

.pl-8px {
  padding-left: 8px;
}

.pr-8px {
  padding-right: 8px;
}

.mt-10px {
  margin-top: 10px;
}

.mt-32px {
  margin-top: 32px;
}

.text__select-check-type {
  font-size: 12px;
  font-weight: 300;
  color: #6e6b7b;
}

.text__asterisk {
  color: #ea5455;
  font-size: 12px;
}

.text__building-card-no {
  font-size: 14px;
  font-weight: 300;
  color: #5e5873;
}

.text__access {
  font-size: 12px;
  font-weight: 300;
  color: #5e5873;
}

.text__access-active {
  color: #7367f0;
}

.text__access-topic {
  font-size: 12px;
  font-weight: 300;
  color: #b9b9c3;
  text-transform: uppercase;
}

.text__access-topic-active {
  color: #7367f0;
}

.text__access-body {
  font-size: 14px;
  font-weight: 400;
  color: #5e5873;
}

.text__access-body-active {
  color: #7367f0;
}

.visitor-info__container {
  max-height: calc(100vh - 250px);
  overflow: auto;
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
  .pl-lg-8px {
    padding-left: 8px;
  }

  .pr-lg-8px {
    padding-right: 8px;
  }

  .w-lg-50 {
    width: 50%;
  }

  .add-multi-visitor-options__container,
  .add-multi-check-in-out-options__container {
    padding: 20px 40px;
    width: 100%;
  }
}
</style>
